import styled from "styled-components";
import { baseColors } from "../../../../themes/definitions/si/cis/base-colors";
import { VoucherGamesListDefaultBox } from "./voucher-games-list.default.box";

export const VoucherGamesListSiBox = styled(VoucherGamesListDefaultBox)`
    box-shadow: 0px 0px 6px ${baseColors.base08Shadow};
    background-color: ${baseColors.gray023};
`;